import React from 'react'
import { Card, Row, Col, Statistic, Alert, Spin, Typography } from 'antd'
import { AndroidOutlined, AppleOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'

const { Text } = Typography

const PlatformCard = ({ title, icon, color, data }) => {
  const unavailable = !data
  return (
    <Card size="small" style={{ borderTop: `3px solid ${color}` }}>
      <div style={{ marginBottom: 8 }}>
        {icon} <Text strong>{title}</Text>
      </div>
      <Row gutter={16}>
        <Col span={12}>
          <Statistic
            title="Всего"
            value={unavailable ? '—' : data.total}
            valueStyle={unavailable ? { color: '#bfbfbf' } : {}}
          />
        </Col>
        <Col span={12}>
          <Statistic
            title="Первичные"
            value={unavailable ? '—' : data.firstTime}
            valueStyle={unavailable ? { color: '#bfbfbf' } : {}}
          />
        </Col>
      </Row>
      <Text type="secondary" style={{ fontSize: 12 }}>
        {unavailable ? 'недоступно' : `сверка по: ${data.lastSyncedAt || '—'}`}
      </Text>
    </Card>
  )
}

PlatformCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node,
  color: PropTypes.string,
  data: PropTypes.object
}

const DownloadsSection = ({ data, loading, error }) => {
  const ios = data && data.ios
  const android = data && data.android
  const warnings = (data && data.warnings) || []

  return (
    <Card
      title="Скачивания приложения"
      size="small"
      style={{ marginBottom: 16 }}
      extra={
        <Text type="secondary" style={{ fontSize: 12 }}>
          App Store / Google Play · задержка публикации 1–2 дня
        </Text>
      }
    >
      {error && (
        <Alert
          type="error"
          showIcon
          message={`Ошибка загрузки: ${error}`}
          style={{ marginBottom: 12 }}
        />
      )}
      {warnings.map((w, i) => (
        <Alert
          key={i}
          type="warning"
          showIcon
          message={w}
          style={{ marginBottom: 12 }}
        />
      ))}
      <Spin spinning={loading}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <PlatformCard
              title="Android"
              icon={<AndroidOutlined style={{ color: '#3ddc84' }} />}
              color="#3ddc84"
              data={android}
            />
          </Col>
          <Col xs={24} md={12}>
            <PlatformCard
              title="iOS"
              icon={<AppleOutlined style={{ color: '#555' }} />}
              color="#8c8c8c"
              data={ios}
            />
          </Col>
        </Row>
      </Spin>
    </Card>
  )
}

DownloadsSection.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.string
}

export default DownloadsSection
